import { useState, useRef, useEffect } from "react";
import './css/AudioRecorder.css';
import microphone from './assets/microphone.png';


const AudioRecorder = ({ saveAudioBlob, saveAudio, audio }) => {
    const mimeType = "audio/mpeg";
    const [permission, setPermission] = useState(false);
    const mediaRecorder = useRef(null);
    const audioChunksRef = useRef([]);
    const objectUrlRef = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [stream, setStream] = useState(null);
    const [audioUrl, setAudioUrl] = useState(null);

    useEffect(() => {
        if (!audio) {
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
                objectUrlRef.current = null;
            }
            setAudioUrl(null);
            return;
        }

        if (objectUrlRef.current) {
            URL.revokeObjectURL(objectUrlRef.current);
            objectUrlRef.current = null;
        }
        setAudioUrl(audio);
    }, [audio]);

    useEffect(() => {
        return () => {
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
            }
        };
    }, []);


    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setPermission(true);
                setStream(streamData);
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    const closeMicrophonePermission = async () => {
        const tracks = stream.getTracks();
        tracks.forEach(track=>{
            track.stop()
        })
        setPermission(false);
    };

    const startRecording = async () => {
        setRecordingStatus("recording");
        audioChunksRef.current = [];
        const media = new MediaRecorder(stream, { type: mimeType });
        mediaRecorder.current = media;
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            audioChunksRef.current.push(event.data);
        };
        mediaRecorder.current.start();
    };

    const stopRecording = () => {
        setRecordingStatus("inactive");
        mediaRecorder.current.onstop = async () => {
            const audioBlob = new Blob(audioChunksRef.current, { type: mimeType });
            audioChunksRef.current = [];
            const nextObjectUrl = URL.createObjectURL(audioBlob);
            if (objectUrlRef.current) {
                URL.revokeObjectURL(objectUrlRef.current);
            }
            objectUrlRef.current = nextObjectUrl;
            const base64Audio = await blobToBase64(audioBlob);
            if (saveAudioBlob) saveAudioBlob(audioBlob);
            if (saveAudio) saveAudio(base64Audio);
            setAudioUrl(nextObjectUrl);
        };
        mediaRecorder.current.stop();
    };

    const recordingBttn = () => {
        if(recordingStatus === "recording"){
            document.querySelector('.recording').style.border = "6px solid black";
            stopRecording()
            closeMicrophonePermission()
            return
        }
        if(permission){
            startRecording()
            document.querySelector('.recording').style.border = "6px solid #4490C3";
            return
        }

        getMicrophonePermission()
        // document.querySelector('.recording').style.backgroundColor = "red";
    };
    

    return (
        <div>
            <div style={{ display: 'flex', fontSize: '0.875em', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '100%', marginTop: '2rem' }}>
                <div className = "recordBttn" onClick={recordingBttn}>
                    <div id="recordingContainer" className="recording">
                        <img id="microphone" style={{ width: '40px', maxWidth: '60px', maxHeight: '40px'}} src={microphone} alt="Example" />
                    </div>
                </div>
                {audioUrl ? (
                    <div className="audio-container" style={{ marginTop: '1.5rem'}}>
                        <audio src={audioUrl} controls></audio>
                    </div>
                ) : null}
                <div className="audio-controls">
                    {!permission ? (
                    <div className="text-prompts">
                        Click to Get Microphone
                    </div>
                    ) : null}
                    {permission && recordingStatus === "inactive" ? (
                    <div className="text-prompts">
                        Click to Start Recording
                    </div>
                    ) : null}
                    {recordingStatus === "recording" ? (
                    <div className="text-prompts">
                        Click to Stop Recording
                    </div>
                    ) : null}
                    {/* {permission ? (
                    <div>
                        Done
                    </div>
                    ) : null} */}
                </div>
            </div>
        </div>
    );
};
export default AudioRecorder;